export const logout = (item: string) => localStorage.removeItem(item)
